// BankInfoBlock.jsx — datos bancarios para transferencia, compartido por Persona y Empresa.

import React from 'react'

const BANK_INFO = {
  titular: "Cuerpo de Bomberos de Quilpué",
  rut: "82.104.901-6",
  banco: "Banco de Chile",
  cuenta: "1491963010",
  correo: "donaciones@bomberosquilpue.cl",
  glosa: "\"Mecánica Para Quilpué\"",
};

function bankInfoAsText() {
  return [
    `Titular: ${BANK_INFO.titular}`,
    `RUT: ${BANK_INFO.rut}`,
    `Banco: ${BANK_INFO.banco}`,
    `Tipo de Cuenta: Cuenta Corriente`,
    `N° de Cuenta: ${BANK_INFO.cuenta}`,
    `Correo: ${BANK_INFO.correo}`,
    `Glosa: ${BANK_INFO.glosa}`,
  ].join("\n");
}

function CopyIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="9" y="9" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
      <path d="M6 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 12.5 9 17.5 20 6.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function BankInfoBlock() {
  const [copied, setCopied] = React.useState(false);

  function copyAll() {
    navigator.clipboard?.writeText(bankInfoAsText()).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div className="bank-info-block">
      <button
        type="button"
        onClick={copyAll}
        className="bank-info-copy-btn"
        aria-label={copied ? "Datos copiados" : "Copiar todos los datos"}
        title={copied ? "Datos copiados" : "Copiar todos los datos"}
      >
        {copied ? <CheckIcon /> : <CopyIcon />}
      </button>
      <div><span className="l">Titular</span><span className="v">{BANK_INFO.titular}</span></div>
      <div><span className="l">RUT</span><span className="v">{BANK_INFO.rut}</span></div>
      <div><span className="l">Banco</span><span className="v">{BANK_INFO.banco}</span></div>
      <div><span className="l">Cuenta Corriente</span><span className="v">{BANK_INFO.cuenta}</span></div>
      <div className="span-2"><span className="l">Correo</span><span className="v">{BANK_INFO.correo}</span></div>
      <div className="span-2"><span className="l">Glosa</span><span className="v accent">{BANK_INFO.glosa}</span></div>
    </div>
  );
}

export { BANK_INFO, BankInfoBlock };
